const numberToWords = num => {
  if (num === 0) return 'zero';

  const belowTwenty = [
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten',
    'eleven',
    'twelve',
    'thirteen',
    'fourteen',
    'fifteen',
    'sixteen',
    'seventeen',
    'eighteen',
    'nineteen'
  ];

  const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

  const scales = ['', 'thousand', 'million', 'billion'];

  const convertLessThanThousand = n => {
    if (n === 0) return '';
    if (n < 20) return belowTwenty[n];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? '-' + belowTwenty[n % 10] : '');

    return belowTwenty[Math.floor(n / 100)] + ' hundred' + (n % 100 ? ' ' + convertLessThanThousand(n % 100) : '');
  };

  let words = '';
  let scaleIndex = 0;

  while (num > 0) {
    let chunk = num % 1000;
    if (chunk) {
      words = convertLessThanThousand(chunk) + (scales[scaleIndex] ? ' ' + scales[scaleIndex] : '') + ' ' + words;
    }
    num = Math.floor(num / 1000);
    scaleIndex++;
  }

  return words.trim();
};
 
export const amountToWords = amount => {
  if (!amount) return 'Zero';

  const [integerPart, decimalPart] = amount.toString().split('.');

  let words = numberToWords(parseInt(integerPart));

  if (decimalPart && parseInt(decimalPart) !== 0) {
    const decimalAsNumber = parseInt(decimalPart.padEnd(2, '0'));
    words += ` point ${numberToWords(decimalAsNumber)}`;
  }

  return words;
};


const numberToArabicWords = num => {
  if (num === 0) return 'صفر';

  const belowTwenty = [
    'صفر',
    'واحد',
    'اثنان',
    'ثلاثة',
    'أربعة',
    'خمسة',
    'ستة',
    'سبعة',
    'ثمانية',
    'تسعة',
    'عشرة',
    'أحد عشر',
    'اثنا عشر',
    'ثلاثة عشر',
    'أربعة عشر',
    'خمسة عشر',
    'ستة عشر',
    'سبعة عشر',
    'ثمانية عشر',
    'تسعة عشر'
  ];

  const tens = ['', '', 'عشرون', 'ثلاثون', 'أربعون', 'خمسون', 'ستون', 'سبعون', 'ثمانون', 'تسعون'];

  const scales = ['', 'ألف', 'مليون', 'مليار'];
 

  const convertLessThanThousand = n => {
  if (n === 0) return '';
  if (n < 20) return belowTwenty[n];
  if (n < 100) {
    return (n % 10 ? belowTwenty[n % 10] + ' و' : '') + tens[Math.floor(n / 10)];
  }

  let hundreds = Math.floor(n / 100);
  let rest = n % 100;

  let hundredPart = '';
  if (hundreds === 1) {
    hundredPart = 'مائة';
  } else {
    hundredPart = belowTwenty[hundreds] + ' مائة';
  }

  return hundredPart + (rest ? ' و' + convertLessThanThousand(rest) : '');
};


  let words = '';
  let scaleIndex = 0;

  while (num > 0) {
    let chunk = num % 1000;
    if (chunk) {
      let chunkWords = convertLessThanThousand(chunk);
      if (scales[scaleIndex]) {
        chunkWords += ' ' + scales[scaleIndex];
      }
      words = chunkWords + (words ? ' و' + words : '');
    }
    num = Math.floor(num / 1000);
    scaleIndex++;
  }

  return words.trim();
};

 export const amountToArabicWords = amount => {
  if (!amount) return 'صفر';

  const [integerPart, decimalPart] = amount.toString().split('.');

  let words = numberToArabicWords(parseInt(integerPart));

  if (decimalPart && parseInt(decimalPart) !== 0) {
    const decimalAsNumber = parseInt(decimalPart.padEnd(2, '0'));
    words += ` فاصلة ${numberToArabicWords(decimalAsNumber)}`;
  }

  return words;
};
